import { Box, Divider, Typography } from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";

import { ToolCard } from "./tool-card";
import { type InternalTool } from "./tools-registry";

const styles = {
  section: { mt: 3.5 },
  heading: { mb: 0.5 },
  rule: { mb: 1.75 },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
    gap: 1.5,
  },
} satisfies Record<string, SxProps<Theme>>;

/** Props for {@link CategorySection}. */
export type CategorySectionProps = {
  /** Category heading. */
  readonly category: string;
  /** Tools shown in this category. */
  readonly tools: InternalTool[];
  /** Called with a tool's path when one of its cards is activated. */
  readonly onOpenTool: (path: string) => void;
};

/**
 * One category block on the launcher: a heading, a divider, and a responsive
 * grid of {@link ToolCard}s.
 */
const CategorySection = ({
  category,
  tools,
  onOpenTool,
}: CategorySectionProps) => {
  return (
    <Box component="section" sx={styles.section}>
      <Typography variant="subtitle1" sx={styles.heading}>
        {category}
      </Typography>
      <Divider sx={styles.rule} />
      <Box sx={styles.grid}>
        {tools.map((tool) => (
          <ToolCard key={tool.name} tool={tool} onOpen={onOpenTool} />
        ))}
      </Box>
    </Box>
  );
};

export default CategorySection;
